
























































import { Component, Vue, Watch, Inject } from "vue-property-decorator";
import gameInfoCom from "./gameInfoCom.vue";
import gameAbstract from "./gameCom/gameAbstract.vue";
import gameRecommend from "./gameCom/gameRecommend.vue";
import gameComment from "./gameCom/gameComment.vue";
import serverList from "./serverList.vue";
import openServerList from "./gameCom/openServerList.vue";
import { gameInfo, EnterGame, EnterGameClient } from "@/req/game";
@Component({
  components: {
    gameInfoCom,
    gameAbstract,
    gameRecommend,
    gameComment,
    serverList,
    openServerList,
  },
})
export default class Home extends Vue {
  public activeMenu = "1";
  public detail: any = {};
  public publicityShow = false
  public gameId: any = "";
  public gameAppid: any = "1";
  public openComment = -1;
  public type: any = "1";
  public typeList = [
    {
      id: "1",
      name: "推荐页",
      path: "/home",
    },
    {
      id: "2",
      name: "新服页",
      path: "/home/newServer",
    },
    {
      id: "3",
      name: "发现页",
      path: "/home/discover",
    },
    {
      id: "4",
      name: "排行页",
      path: "/home/list",
    },
    {
      id: "5",
      name: "个人中心",
      path: "/user",
    },
    {
      id: "6",
      name: "用户主页",
      path: "/otherUser",
    },
  ];
  public todayOpenList: any = []; // 今日开服
  public mounted() {
    if (this.$route.params.id) {
      this.gameId = this.$route.params.id.slice(0, -5);
    }
    if (this.$route.params.comment && this.$route.params.comment != "99") {
      this.activeMenu = "2";
    }
    if (this.$route.params.type) {
      this.type = this.$route.params.type;
    }
    this.getDetail();
  }
  @Watch("$route")
  public routeChange(i) {
    this.gameId = this.$route.params.id.slice(0, -5);
    if (this.$route.params.comment && this.$route.params.comment != "99") {
      this.activeMenu = "2";
    }
    this.getDetail();
  }
  @Watch("$route.params.id")
  public changeIds() {
    this.activeMenu = "1";
  }
  public changeId(id) {
    this.getDetail();
  }
  // 获取游戏详情
  public async getDetail() {
    const obj: any = {
      token: this.$fn.cookies.getToken(),
      box_game_id: this.$route.params.id.slice(0, -5),
    };
    const res = await gameInfo(obj);
    if (res.code == 200) {
      this.detail = res.data.game_info;
      this.detail.publicity[0] == undefined ? this.publicityShow = true : this.publicityShow = false
      this.gameAppid = res.data.game_info.game_appid;
      this.openComment = res.data.game_info.open_comment;
      res.data.today_open.forEach((item, index) => {
        this.$set(item, "lefts", 0);
        this.$set(item, "widths", 0);
        this.$set(item, "shows", false);
        if (index == 0) {
          item.lefts = 40;
          item.widths = 11.5;
        }
        if (index == 1) {
          item.lefts = 294;
          item.widths = 34.5;
        }
        if (index == 2) {
          item.lefts = 548;
          item.widths = 56.5;
        }
        if (index == 3) {
          item.lefts = 802;
          item.widths = 100;
        }
      });
      this.todayOpenList = res.data.today_open;
      // 获取当前时间戳
      const date = new Date().getTime() / 1000;
      setTimeout(() => {
        this.todayOpenList.forEach((items) => {
          if (items.open_time <= date) {
            items.shows = true;
          } else {
            items.shows = false;
          }
        });
      }, 0);
    }
  }
  public getRouter(item) {
    if (item.id == "6") {
      this.$fn.toOtherUser(this.$route.params.uids);
    } else {
      this.$router.push(item.path);
    }
  }
}
